<template>
  <el-container >
    <el-header  class="el-header">
      <Top />
    </el-header>
    <el-container class="el-container">
      <el-aside  class="el-aside" width="200px">
        <Menu />
      </el-aside>
      <el-container>
        <el-main class="el-main">
          <router-view />
        </el-main >
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import Top from '../components/Header.vue'
import Menu from '../components/Menu.vue'
export default {
  components: {
    Top,
    Menu
  },
}
</script>

<style>
.el-container{
  display: flex;
  /*align-items: stretch;*/
}
.el-header {
  line-height: 60px;
  width: 100vw;
  padding: 0;
}

.el-aside {
  /*display: flex;*/
  /*flex:1;*/
  _color: #451576;
  /*background-color: #B3C0D1;*/
  /*border: 1px solid #333;*/
  padding: 0px;
  /*height: 1000px;*/
  height: calc(100vh - 80px);
  /*border: 1px solid black;*/
  background-color: #545c64;
}

.el-main {
  /*display: flex;*/
  /*flex:8;*/
  /*border: 0px solid #333;*/
  /* padding: 0px; */
  height: calc(100vh - 80px);
  /*border: 1px solid black;*/
  background-color: #fff;
  /* background-image: url(https://oss.jlszhgh.com/employment/images/pc-bj.jpg); */
}
</style>



// WEBPACK FOOTER //
// src/pages/MyMain.vue